import React, { forwardRef, Ref } from "react";
import { colors } from "../../stitches.config";
import {
  // eslint-disable-next-line no-restricted-imports
  Body as StyledBody,
  TextSize,
  // eslint-disable-next-line no-restricted-imports
  Title as StyledTitle,
} from "./__styles__/Typography";

type AllowedStyleOverrides = Omit<
  React.CSSProperties,
  "fontWeight" | "fontSize" | "lineHeight" | "color"
>;

const titleSizeToHtmlTag = {
  small: "h3",
  default: "h2",
  large: "h1",
} as const;

export type TitleType = "semiBold" | "regular";

export const Title = ({
  size,
  type,
  color = "contentPrimary",
  style,
  children,
  id,
}: {
  size: TextSize;
  type: TitleType;
  color?: keyof typeof colors;
  style?: AllowedStyleOverrides;
  children: React.ReactNode;
  id?: string;
}) => {
  const css = { color: colors[color].toString() };

  return (
    <StyledTitle
      size={size}
      type={type}
      color={color}
      css={css}
      style={style}
      as={titleSizeToHtmlTag[size]}
      id={id}
    >
      {children}
    </StyledTitle>
  );
};

export type BodyType = "emphasis" | "regular" | "underline";

export const Body = forwardRef(
  (
    {
      size,
      type,
      color = "contentPrimary",
      style,
      as = "p",
      testId,
      children,
    }: {
      size: TextSize;
      type: BodyType;
      color?: keyof typeof colors | "inherit";
      style?: AllowedStyleOverrides;
      as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
      testId?: string;
      children: React.ReactNode;
    },
    ref: Ref<HTMLParagraphElement>
  ) => {
    const css = {
      color: color === "inherit" ? "inherit" : colors[color].toString(),
    };

    return (
      <StyledBody
        size={size}
        type={type}
        css={css}
        style={style}
        as={as}
        data-testid={testId}
        ref={ref}
      >
        {children}
      </StyledBody>
    );
  }
);
